import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, ElementRef, HostListener, inject, Input, ViewChild } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SsrService } from '@services/ssr.service';
import { ScrollbarService } from '@services/scrollbar.service';

@Component({
  selector: 'app-tooltip',
  imports: [NgClass, NgStyle],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
})
export class TooltipComponent implements AfterViewInit {
  private cd = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private ssrService = inject(SsrService);
  private scrollbarService = inject(ScrollbarService);
  @Input() content?: string;
  @Input() element?: HTMLElement | null;
  @Input() position: 'top' | 'bottom' = 'top';
  @Input('z-index') zIndex: 'default' | 'max' = 'default';
  @ViewChild('tooltip') tooltip?: ElementRef;
  public active: boolean = false;
  public top?: string;
  public bottom?: string;
  public left?: string;
  public arrowOffset: number = 0;

  @HostListener('window:resize') onResize(): void {
    this.setPosition();
  }

  @HostListener('window:scroll') onScroll(): void {
    this.setPosition();
  }

  initPosition(): void {
    if (this.ssrService.isServer()) return;
    setTimeout(() => {
      this.setPosition();
      this.cd.detectChanges();
    });
  }

  setPosition(): void {
    if (this.ssrService.isServer()) return;
    if (!this.element) return;
    const buttonEl: HTMLElement | null = this.element;
    const buttonElTop: number = buttonEl.getBoundingClientRect().top;
    const buttonElLeft: number = buttonEl.getBoundingClientRect().left;
    const buttonElHeight: number = buttonEl.getBoundingClientRect().height;
    if (this.position === 'top') {
      this.top = 'auto';
      this.bottom = window.innerHeight - buttonElTop + 12 + 'px';
    } else {
      this.bottom = 'auto';
      this.top = buttonElTop + buttonElHeight + 12 + 'px';
    }
    const size = this.tooltip?.nativeElement.getBoundingClientRect().width ?? 300;
    const arrowHalfSize = 6;
    const halfSize = size ? size / 2 : 140;
    this.left = buttonElLeft + buttonEl.offsetWidth / 2 - halfSize + 'px';
    this.arrowOffset = halfSize - arrowHalfSize;
    if (parseInt(this.left) < 10) {
      this.left = '10px';
      this.arrowOffset = buttonElLeft + buttonEl.offsetWidth / 2 - arrowHalfSize;
    } else if (parseInt(this.left) + size > window.innerWidth - 10) {
      this.left = window.innerWidth - size - 10 + 'px';
      this.arrowOffset = buttonElLeft + buttonEl.offsetWidth / 2 - (window.innerWidth - size - arrowHalfSize);
    }
    this.active = true;
  }

  constructor() {
    this.scrollbarService.value$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.setPosition();
    });
  }

  ngAfterViewInit(): void {
    this.initPosition();
  }
}
